import { WSPoster, WSPosterProps } from "@wingspanhq/fe-component-library";
import React from "react";
import { useIsMobile } from "@wingspanhq/fe-component-library";

export const RequirementCardContent: React.FC<WSPosterProps> = props => {
  const isMobile = useIsMobile();

  return <WSPoster align={isMobile ? "center" : "left"} size="S" {...props} />;
};
